import * as BaseApi from "api/Base.api";
import { IUserSchoolStudent } from "../../../interfaces/user.interface";

const BASE_URL = "/school/v2/student/list";

//* 원생 목록 조회
//  희문
//  2025. 08. 08

export interface IStudentListParams {
    studentList: IUserSchoolStudent[];
}
export const getStudentList = async (): Promise<IStudentListParams> => {
    const url = `${BASE_URL}`;
    return await BaseApi.get(url);
};